// Hamburger Animation
$(".hamburger").click(function () {
    $(this).toggleClass("is-active");
});

$(".js-nav-control").click(function () {
    $('body').toggleClass('open');
});


// Smooth Scroll Animation


// SEARCH
  $('#search-pop').hide();

  $(".js-show-search").click(function(){
    $("#search-pop").toggleClass('visible').slideToggle(500).find('input').focus();
  });


 // #### QUANTITY INCREMENTER ####
 
 $('.js-qty-wrap').each(function() { 
	 var addInput = '.js-qty-wrap'; 
	 var inputEl = $(this).closest(addInput).find('input');
	 var n = inputEl.val();
	 var plusEl = $(this).closest(addInput).find('.plus');
	 var minEl = $(this).closest(addInput).find('.minus');
	  //On plus click add 1 to n
	  plusEl.on('click', function(){
		inputEl.val(++n);
	   });
		  
		  //On min click
		   minEl.on('click', function(){
		  // If n is bigger or equal to 1 subtract 1 from n 
		 if ( ( inputEl.val() ) >= 1) {
			 inputEl.val(--n);
	 }
 });
});


// CHANGE IMAGE WITH VARIANT CHANGE
(function (window, $) {
    $(document).ready(function () {
        $('body')
            .on('change', '#productSelect', function (event) {
                // Update Price
                var selected = this.options[this.selectedIndex],
                    variantPrice = selected.dataset.price;

                $('#productPrice').text(variantPrice);

                /** Update image Slider */
                var variantImage = selected.dataset.image;
                var position = -1;

                $('.product-thumbs .single-thumb').each(function () {
                    if ($(this).data('image') == variantImage) {
                        position = parseInt($(this).data('slick-index'));
                        return;
                    }
                });

                if (position != -1) {
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
                }


                /** Update Nutritions table tab content */
                if (this.options.length > 1 && window.product_variants !== undefined) {
                    product_variants.forEach((variant_meta) => {
                        if (variant_meta.id == selected.value) {
                            for (const [key, value] of Object.entries(variant_meta)) {
                                $(`.js-meta-${key}`).empty().html(value);
                            }
                        }
                    });
                }
            })
    })
})(window, jQuery);


// Footer Nav

function resizeHandler() {
    console.log("window resized");

    if ($(window).width() < 767) {
        console.log("window small than 600");

        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 767) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});

// COLLAPSIBLE SECTIONS ON RECHARGE BUNDLE PRODUCT TEMPLATE
if($('#recharge-bundles').length){
  $(document).on("click", ".rb-section-header" , function() {
    //console.log("bundle header clicked");
    $(this).toggleClass('expanded');
    $(this).next('.rb-collapsible').slideToggle(500);
  });
}

// Vendor: Animate On Scroll (AOS)
//  https://github.com/michalsnik/aos
AOS.init({
  //disable: window.innerWidth < 992,
  mirror: true
});

// ADJUST AOS SETTINGS WHEN IN CUSTOMIZER
/*
Determines if the current page is in an iframe element, if so it means the page is being viewed in the customizer
Class .aos-is-in-iframe is applied by default on the body in theme.liquid
If the page is not being viewed in an iframe (customizer), the class .aos-is-in-iframe gets removed from the body so that aos css animations will work
*/
 var isIframe = false;
 if (window.location !== window.parent.location) {
   var isIframe = true;
 } 
 $('body').attr('data-iframe', isIframe);
